import { render, staticRenderFns } from "./SubServiceDetail.vue?vue&type=template&id=471c771c&scoped=true&"
import script from "./SubServiceDetail.vue?vue&type=script&lang=js&"
export * from "./SubServiceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471c771c",
  null
  
)

export default component.exports